module.exports = __webpack_public_path__ + "ed98930e87cff2062ec21901d32afeba.png";